import React from "react";
import { Button } from "semantic-ui-react";
import ReactTable, { ReactTableDefaults } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/pro-regular-svg-icons";
import { saveAs } from "file-saver";
import moment from "moment";

const DiagnoseOverviewPerformances = ({ report, t }) => {
  if (!report.report_data) {
    return (
      <>
        <h3 className="report-heading">{t(report.report_name).message || report.report_name}</h3>
        <p className="no-data">{t("no_data").message || "No data"}</p>
      </>
    );
  }

  const data = report.report_data.map(d => JSON.parse(d));

  const exportData = async () => {
    let csv = "";
    let header = (t("location").message || "Location") + ", ";
    header += (t("not_answered_advised_item").message || "Not Answered (Advised items)") + ", ";
    header += (t("accepted_advised_item").message || "Accepted (Advised items)") + ", ";
    header += (t("refused_advised_item").message || "Refused (Advised items)") + ", ";
    header += (t("contact_me_advised_item").message || "Contact Me (Advised items)") + ", ";
    header += (t("accepted_critical_item").message || "Accepted (Critical items)") + ", ";
    header += (t("refused_critical_item").message || "Refused (Critical items)") + ", ";
    header += t("contact_me_critical_item").message || "Contact Me (Critical items)";

    let values = data
      .map(
        d =>
          d.location +
          ", " +
          d.not_answered_advised_item +
          ", " +
          d.accepted_advised_item +
          ", " +
          d.refused_advised_item +
          ", " +
          d.contact_me_advised_item +
          ", " +
          d.accepted_critical_item +
          ", " +
          d.refused_critical_item +
          ", " +
          d.contact_me_critical_item
      )
      .join("\n");

    csv += header + "\n" + values;
    saveAs(new File([csv], { type: "text/csv;charset=utf-8" }), "DiagnoseOverviewPerformances_" + moment().format("YYYYMMDD") + ".csv");
  };

  return (
    <>
      <h3 className="report-heading">
        {t(report.report_name).message || report.report_name}
        <Button color="green" floated="right" basic onClick={() => exportData()}>
          <span style={{ marginRight: "10px" }}>{t("export").message || "Export"}</span>
          <FontAwesomeIcon icon={faFileExport} />
        </Button>
      </h3>
      <div className="dealer-reports-table-container">
        <ReactTable
          className="ReactTable -floated-table no-overflow all-data-table -initial-margin"
          data={data}
          showPagination={false}
          showPageSizeOptions={false}
          sortable={false}
          style={{ maxHeight: "600px" }}
          resizable={false}
          defaultPageSize={data.length || 0}
          pageSize={data.length || 0}
          noDataText={
            <div className="Table__no-results">
              <p>{t("no_data").message || "No data"}</p>
            </div>
          }
          column={{
            ...ReactTableDefaults.column,
            headerClassName: "ReactTable__column-header dealer-table-header",
            className: "ReactTable__column",
          }}
          columns={[
            {
              Header: <strong>{t("location").message || "Location"}</strong>,
              accessor: "location",
            },
            {
              Header: <strong>{t("not_answered_advised_item").message || "Not Answered (Advised items)"}</strong>,
              accessor: "not_answered_advised_item",
            },
            {
              Header: <strong>{t("accepted_advised_item").message || "Accepted (Advised items)"}</strong>,
              accessor: "accepted_advised_item",
            },
            {
              Header: <strong>{t("refused_advised_item").message || "Refused (Advised items)"}</strong>,
              accessor: "refused_advised_item",
            },
            {
              Header: <strong>{t("contact_me_advised_item").message || "Contact Me (Advised items)"}</strong>,
              accessor: "contact_me_advised_item",
            },
            {
              Header: <strong>{t("accepted_critical_item").message || "Accepted (Critical items)"}</strong>,
              accessor: "accepted_critical_item",
            },
            {
              Header: <strong>{t("refused_critical_item").message || "Refused (Critical items)"}</strong>,
              accessor: "refused_critical_item",
            },
            {
              Header: <strong>{t("contact_me_critical_item").message || "Contact Me (Critical items)"}</strong>,
              accessor: "contact_me_critical_item",
            },
          ]}
        />
      </div>
    </>
  );
};

export { DiagnoseOverviewPerformances };
